import component from "./ProfileRaiseAlert.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileRaiseAlert"

export default wrapVueComponent(componentName, component)
